import { ReactElement } from 'react'
import { FormField } from '@myeh/design-system'

import { MESSAGE_FILTERS } from '../../../lib/constants'
import { Lob } from '../../../models/Message'

interface Props {
  setLobFilter: React.Dispatch<React.SetStateAction<string | undefined>>
}

interface DropdownOption {
  value: string
  label: string
}

export function FilterByLob({ setLobFilter }: Props): ReactElement {
  const dropdownLOB: Array<DropdownOption> = Object.values(Lob).map((value) => ({
    value,
    label: value
  }))
  dropdownLOB.unshift({
    value: MESSAGE_FILTERS.ALL_VALUE,
    label: 'All'
  })
  const filterByLob = (value: Lob | string) => {
    setLobFilter(value)
  }
  return (
    <>
      <div className='w-50 pa2'>
        <FormField.Dropdown
          name='type-filter'
          label='Line of business'
          items={dropdownLOB}
          onChange={filterByLob}
          data-testid='line-of-business-filter'
        />
      </div>
    </>
  )
}
